const internals = {};

internals.buildDefaults = () => ({
    selectedRole: '',
    selectedUsers: []
});

internals.buildFields = () => {
    const defaults = internals.buildDefaults();

    return [
        {
            name: 'selectedRole',
            type: 'SelectField',
            default: defaults.selectedRole
        },
        {
            name: 'selectedUsers',
            type: 'MultiSelectField',
            default: defaults.selectedUsers
        }
    ];
};

module.exports.buildFormConfig = function buildFormConfig() {

    return {
        formId: 'survey-list-item-invite-form',
        fields: internals.buildFields(),
        defaults: internals.buildDefaults(),
        formOptions: {
            mode: 'onChange'
        },
        syncDefaults: false
    };
};

module.exports.internals = internals;
